import palette from '../palette_dark';

const MuiCard = {
    root: {
        padding: '16px',
        border: palette.card_border,
    },
};

export default MuiCard;